<script lang="ts" setup>
import ProductSort from '~/enums/product-sort'

const model = defineModel<ProductSort>()
</script>

<template>
  <DropdownMenu icon-name="outlined/sort" position="left">
    <template #label>
      {{ ProductSort.getName(model!) }}
    </template>

    <DropdownMenuItem v-for="x in ProductSort.sortedMembers" :key="x" class="whitespace-nowrap" @click="model = x">
      {{ ProductSort.getName(x) }}
    </DropdownMenuItem>
  </DropdownMenu>
</template>
